import React from "react";
import Card, { CardLabel, CardSub, CardUnit, CardValue } from "./Card";
import DeltaValue from "../DeltaValue/DeltaValue";

/**
 * Carte KPI simple : libellé + grande valeur + unité.
 * Si `section` et `tip` sont fournis, la valeur devient survolable
 * ("vs précédent" : couleur au hover + tooltip donnant le contenu de `tip`).
 * Le texte du tooltip est entièrement à la charge de l'appelant.
 */
const KpiCard = ({ label, value, unit, sub, section, tip, ...props }) => {
    return (
        <Card indicatorLabel={label} {...props}>
            <CardLabel>{label}</CardLabel>
            <CardValue>
                {section ? (
                    <DeltaValue section={section} tip={tip}>
                        {value}
                    </DeltaValue>
                ) : (
                    value
                )}
                {unit && <CardUnit>{unit}</CardUnit>}
            </CardValue>
            {sub && <CardSub>{sub}</CardSub>}
        </Card>
    );
};

export default KpiCard;
